import React from 'react';
import classNames from 'classnames';
import { QualificationQuestionType } from 'models/DealRoom';
import { FieldArray } from 'react-final-form-arrays';
import { Button } from 'ncoded-component-library';
import PlusIcon from 'icons/Plus.icon';
import EditQuestion from './components/EditQuestion';
import { useTranslation } from 'react-i18next';
import { uuid4 } from '@sentry/utils';

import './EditQualificationQuestions.styles.scss';
import './EditQualificationQuestions.styles.responsive.scss';

const ADD_NEW_QUESTION_INITIAL: QualificationQuestionType = {
  title: '',
  autoFocus: true,
  answers: [],
};

type EditQualificationQuestionsProps = {
  className?: string;
};

const EditQualificationQuestions: React.FC<EditQualificationQuestionsProps> = (
  props,
) => {
  const { className } = props;

  const classes = classNames('edit-qualification-questions', className);

  const { t } = useTranslation();

  return (
    <div className={classes}>
      <FieldArray name="qualificationQuestions">
        {({ fields }) => (
          <>
            {fields.map((name, index) => {
              return (
                <EditQuestion
                  key={name}
                  name={name}
                  onRemove={() => fields.remove(index)}
                />
              );
            })}

            <Button
              variant="link"
              icon={PlusIcon}
              onClick={() => {
                fields.push({ ...ADD_NEW_QUESTION_INITIAL, id: uuid4() });
              }}
            >
              {t('addQuestion')}
            </Button>
          </>
        )}
      </FieldArray>
    </div>
  );
};

export default EditQualificationQuestions;
